export const vossPaymentStatus = {
    Unpaid: 0,
    Paid: 1,
}